<loader-overlay-component [show]="isloading"></loader-overlay-component>

  <div class="container maxWidth540">
    <div class="row">
      <div class="col-12 text-center">
        <div class="global-wrapper">
          <div>
            <img src="{{globalService.externalResourcesUrl}}logo.svg" class="img-fluid logo">
          </div>

          <div>
            <img src="{{globalService.externalResourcesUrl}}Icon-logo-meg-wordmark.svg" class="img-fluid logo-white">
          </div>
          
          <div class="chooseYour" [innerHTML]="defaultEntryPointWelcomeText"></div>
          <div class="col-12 col-sm-8 col-md-6  m-auto" role="alert" *ngIf="errorMessage">
              <div class="alert alert-danger homeError">   
                  {{errorMessage}}
              </div>
           </div>
           <div class="col-12 col-sm-8 col-md-6  m-auto" role="alert" *ngIf="errorMessageForQrCode">
            <div class="alert alert-danger homeError">   
                {{errorMessageForQrCode}}
            </div>
         </div>
          <div class="col-12 col-sm-8 col-md-6  m-auto" *ngIf="!errorMessage">
            <select [ngClass]="{'mdb-select': globalService.browserDetails.isDesktop}" class="select-form" (change)="selectCounty($event.target.value)">
                <option value="-1">Select a County</option>
                <option *ngFor='let agency of (megStoreService.configurationsData$ | async)?.megConfig?.agencies'
                [value]="agency.agencyID">
                {{agency.name}}
              </option>
            </select>
          </div>
         
          <!-- end .select-wrapper -->
        </div>
      </div>
    </div>
  </div>
